import { Session } from '@shared/app/scripts/services/session';
import { LocationManager } from '@shared/app/scripts/services/location-manager';

/**
 * @ngdoc service
 * @name posApp.mainInit
 * Service that is injected to set up main dependecies
 */
angular.module('posApp').service('mainInit', () => {
  return {
    firstTime: true,
  };
});
